import { render, staticRenderFns } from "./CertificateAccount.vue?vue&type=template&id=3fee7406&scoped=true&"
import script from "./CertificateAccount.vue?vue&type=script&lang=js&"
export * from "./CertificateAccount.vue?vue&type=script&lang=js&"
import style0 from "./CertificateAccount.vue?vue&type=style&index=0&id=3fee7406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fee7406",
  null
  
)

export default component.exports